import { render, staticRenderFns } from "./PedidosDiario.vue?vue&type=template&id=1c171d5b&scoped=true&"
import script from "./PedidosDiario.vue?vue&type=script&lang=js&"
export * from "./PedidosDiario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c171d5b",
  null
  
)

export default component.exports